import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { TicketCategory } from "@/api/tickets/tickets.ts";
import { useMemo } from "react";

// Категории для тикетов к арендодателю
export function UserToLandlordCategoryHandbook(
  props: AutocompleteProps<TicketCategory>,
) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  const filteredItems = useMemo(() => {
    return items.filter((item) => item.type === "user_to_landlord");
  }, [items]);

  return (
    <Autocomplete
      defaultItems={filteredItems}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      {...props}
    >
      {(item: TicketCategory) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

// Категории для тикетов к платформе
export function ToPlatformCategoryHandbook(
  props: AutocompleteProps<TicketCategory>,
) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  const filteredItems = useMemo(() => {
    return items.filter((item) => item.type === "to_platform");
  }, [items]);

  return (
    <Autocomplete
      defaultItems={filteredItems}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      {...props}
    >
      {(item: TicketCategory) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

// Общий хендбук для всех категорий (для обратной совместимости)
export function NewCategoryHandbook(props: AutocompleteProps<TicketCategory>) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  return (
    <Autocomplete
      defaultItems={items}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      {...props}
    >
      {(item: TicketCategory) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

// Хендбук для FormBuilder (для обратной совместимости)
export function CategoryHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
}) {
  const items = useAppSelector((state) => state.handbooks.ticketCategory);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Категория"
      placeholder="Выберите категорию"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}
    >
      {(item: TicketCategory) => (
        <AutocompleteItem
          key={String(item.id)}
        >{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
